import React from 'react';
import { Button, Modal } from '@/components';
import { useTranslation } from 'react-i18next';
import styles from './Modals.module.css';

interface PreventionModalProps {
  onClose: () => void;
  onDiscard: () => void;
  onBack: () => void;
}

function PreventionModal({ onClose, onDiscard, onBack }: PreventionModalProps) {
  const { t } = useTranslation();

  return (
    <Modal modalStyles={{ maxWidth: '480px' }} handleClose={onClose}>
      <div className={styles.modal}>
        <h2 className={`${styles.modalTitle} ${styles.mb16}`}>{t('account.prevent.title')}</h2>
        <div className={`${styles.modalDescription} ${styles.mb40}`}>
          {t('account.prevent.description')}
        </div>

        <div className={styles.modalButton}>
          <Button theme="cta" style={{ marginBottom: '8px' }} onClick={onBack}>
            {t('account.prevent.back')}
          </Button>
          <Button theme="plain" onClick={onDiscard}>
            {t('account.prevent.discard')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default PreventionModal;
